const ResourceDivider = () => {
  return <span className="r-0 absolute left-0 top-[-1px] h-[1px] w-screen bg-fog-20" />;
};

export { ResourceDivider };
